import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
import './login.css';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import swal from "sweetalert";

import { resetMiscData, setAgentInfo, setClientRole, setDeviceInfo, setLoginTimestamp, setLogoutEnabled, setRequesterId, setToken } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class WhiteLabelLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: ''
        }
    }

    componentDidMount() {
        store.dispatch(setAgentInfo(''));
		store.dispatch(resetMiscData);

        setTimeout(() => {
            this.loginFunction();
        }, 500);
          
    }

    componentWillUnmount() {
    }

    loginFunction = () => {


        var query = window.location.search.substring(1);

        query = query.replace("/whitelabel", "");
        query = query.replace("/login", "");

       
        var params = query.split("?")[0];

        var vars = params.split("&");
        console.log(vars);

        var encData = "";
      

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            console.log("pair: " + pair);
            if (pair[0] == "encData" || pair[0] == "encdata") {
                encData = pair[1];
                console.log("encData=" + encData);
                var mainData=atob(encData);
             
                var jsonObj=JSON.parse(mainData)
                var agentId=jsonObj.agentId;
                var token=jsonObj.token;
                var role=jsonObj.role;
                var requestredId=jsonObj.requesterId;
                var logourEnabled=jsonObj.logourEnabled;
                store.dispatch(setAgentInfo(agentId));
                store.dispatch(setToken(token));
                store.dispatch(setClientRole(role))
                store.dispatch(setRequesterId(requestredId));
                store.dispatch(setLogoutEnabled(logourEnabled));

                store.dispatch(setLoginTimestamp(new Date()));

                setTimeout(() => {
                    history.push('/dashboard');
                    history.go();
            
                }, 700);
                
                
            }else{
                swal({
                    title: "Malformed request!",
                    text: 'Retry or please contact admin.',
                    icon: "error",
                    button: true,
                    dangerMode: true,
                })
                .then(() => {
                   history.push('/');
                   history.go();
                });
            }
           
          
        }

    }

    render() {

        return (

            <div></div>

        );
    }
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
		miscReduce: { phone } }
) => ({
	errorMessage, loginErrorMessage, otpErrorMessage, phone
});

export default connect(mapStateToProps, null)(WhiteLabelLogin);
